export default __webpack_public_path__ + "static/media/l32.ab8d293e.png";